<div class="welcome-mesage">
  <div class="welcome-title">
    <span>{{ 'pageTitle.producers' | translate }}</span>
    <span>{{ 'pageTitle.portal' | translate }}</span>
  </div>
</div>

<div class="welcome-content-container">
  <div class="welcome-logo">
    <rtl2-logo [size]="400" [color]="'#ffe600'"></rtl2-logo>
  </div>

  <div class="welcome-content">
    <ng-content></ng-content>
  </div>
</div>
